'use strict';

module.exports = {
    formDefinitionTypes: require('./formDefinitionsTypes')
};